<script lang="ts">
	import ArrowUp from 'assets/svg/arrowUp.svg?component';
	import ArrowDown from 'assets/svg/arrowDown.svg?component';

	export let width: number;
	export let height: number;
	export let isPressed = false;
	export let pressedIconId: string | number;
	export let idToCompare: string | number;
</script>

<div class="arrow-wrapper">
	<ArrowUp
		class={`filter-icon ${pressedIconId === idToCompare && isPressed ? 'active' : ''}`}
		{width}
		{height}
	/>

	<ArrowDown
		class={`filter-icon ${pressedIconId === idToCompare && !isPressed ? 'active' : ''}`}
		{width}
		{height}
	/>
</div>

<style lang="scss">
	@import 'sortingArrow';
</style>
